import React from "react";

const Test1 = () => {
  return (
    <div className="flex flex-col items-center justify-center mx-auto w-full px-2 sm:px-4">
      <div className="flex flex-col justify-center max-w-6xl mx-auto w-full">
        <h1 className="text-2xl mb-4 text-center font-bold text-dark-black">
          A STANDARD PAGE HEADER
        </h1>

        <p className="mb-4 text-red-600 text-sm leading-relaxed">
          Standard page header font info: Font type: Tahoma, Font size: 24px,
          Font color code: #242124, Bold: Yes, space size above it: 16px, Space size below it: 16px.
        </p>

        <div>
          <h2 className="text-[18px] font-bold text-dark-black mb-4">
            A Standard Paragraph Header
          </h2>

          <p className="text-red-600 leading-relaxed mb-4 text-sm">
            Standard paragraph header font info: Font type: Tahoma, Font size:
            18px, Font color code: #242124, Bold: Yes, space size above it: 0, Space size below it: 16px.
          </p>

          
          <p className="text-dark-black leading-relaxed mb-4 text-sm">
            Lerem ipsum dolor sit amet, consectetur adipiscing elit. Sed
            do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
            ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
            in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
            sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
            mollit anim id est laborum.
          </p>
          <p className="text-red-600 leading-relaxed mb-4 text-sm">
            Standard body text font info: Font type: Tahoma, Font size: 14px,
            Font color code: #242124, Bold: No, space size above it: 0, Space size below it: 16px.
          </p>
        </div>
      </div>
      <div className="border-b-[8px] border-red-600 border-dashed w-full my-6 mx-auto max-w-6xl flex items-center justify-center relative">
        <span className="absolute text-red-600 left-1/2 -translate-x-1/2 bg-white px-2 whitespace-nowrap sm:px-4 font-bold text-base sm:text-lg md:text-xl" style={{ top: '-10px' }}>
          MOBILE DEVICE SECTION
        </span>
      </div>
      <div className="flex flex-col justify-center max-w-6xl mx-auto w-full">
        <h1 className="text-2xl mb-4 text-center font-bold text-dark-black">
          A STANDARD PAGE HEADER
        </h1>

        <p className="mb-4 text-red-600 leading-relaxed">
          Standard page header font info: Font type: Tahoma, Font size: 24px,
          Font color code: #242124, Bold: Yes, space size above it: 16px, Space size below it: 16px.
        </p>
        <div>
          <h2 className="text-lg font-bold text-dark-black mb-4">
            A Standard Paragraph Header
          </h2>

          <p className="text-red-600 leading-relaxed mb-4">
            Standard paragraph header font info: Font type: Tahoma, Font size:
            18px, Font color code: #242124, Bold: Yes, space size above it: 0, Space size below it: 16px.
          </p>

          
          <p className="text-dark-black leading-relaxed mb-4">
            Lerem ipsum dolor sit amet, consectetur adipiscing elit. Sed
            do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
            ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
            in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
            sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
            mollit anim id est laborum.
          </p>
          <p className="text-red-600 leading-relaxed mb-4">
            Standard body text font info: Font type: Tahoma, Font size: 16px,
            Font color code: #242124, Bold: No, space size above it: 0, Space size below it: 16px.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Test1;
